import { useRef, useState, useEffect } from 'react';
import { BusinessCardField, BusinessCardLocationData } from '../../types';

interface CustomizeItemPreviewProps {
  previewImage?: string | null;
  productImages?: string[];
  data: BusinessCardLocationData;
  fields: BusinessCardField[];
  fontColor?: string;
}

// const PHONE_FIELDS = ['phone', 'cell_phone', 'fax', 'customer_service_phone', 'toll_free'];
const META_FIELDS = ['is_saved_address', 'address_group', 'slight_bar'];

export function CustomizeItemPreview({ previewImage, productImages, data, fields, fontColor }: CustomizeItemPreviewProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);
  const CANVAS_WIDTH = 700;

  const imageUrl = previewImage || productImages?.[0];

  useEffect(() => {
    if (!containerRef.current) return;
    const update = () => {
      const w = containerRef.current?.offsetWidth || CANVAS_WIDTH;
      setScale(w / CANVAS_WIDTH);
    };
    update();
    const observer = new ResizeObserver(update);
    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  if (!imageUrl) return null;

  const effectiveColor = fontColor || '#000000';
  const baseFontSize = 17 * scale;

  const renderableFields = fields.filter(
    f => !META_FIELDS.includes(f.key) && data[f.key]
  );

  return (
    <div style={{ width: '100%', maxWidth: `${CANVAS_WIDTH}px` }}>
      <div
        ref={containerRef}
        className="relative overflow-hidden rounded-lg border border-gray-200 shadow-sm"
        style={{ width: '100%' }}
      >
        <img src={imageUrl} alt="Item Preview" className="w-full h-auto block" />
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            color: effectiveColor,
            fontSize: `${baseFontSize}px`,
            lineHeight: 1.5,
          }}
        >
          {renderableFields.map(field => (
            <div key={field.key} style={{ marginBottom: `${4 * scale}px` }}>
              {data[field.key]}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
